module.exports = __webpack_public_path__ + "static/media/cover_ger_4_5.d934f29b.jpg";